import _ from 'lodash/fp'
import queryString from 'query-string'

export const genericWordKiller = (stringWithGenericWords) => {
  const highlyGenericWords = ['golf', 'klub', 'club', 'klubb', 'klúbbur', 'klúbburinn']
  const lessGenericWords = ['country', 'and', 'spa', '&']
  const parts = _.split(' ', stringWithGenericWords)
  const relevantParts = _.reject((part) => {
    return _.reduce((acc, genericWord) => {
      return acc || _.includes(genericWord, _.toLower(part)) || _.includes(part, lessGenericWords)
    }, false, highlyGenericWords)
  }, parts)
  return _.join(' ', relevantParts)
}

export const sortByAndMap = (field, f, data) => _.flow(
  _.sortBy(field),
  _.map(f)
)(data)

export const searchParamsToObject = (location) => {
  if (!location.search) {
    console.warn('tried to access search params when none were present', location)
    return {}
  }
  const parsed = queryString.parse(location.search)
  return parsed
}
